module.exports = __webpack_public_path__ + "img/scan-no-data.39b9c314.png";